/**
 * ViewControlsBar - Structural shell for the toolbar above a card view
 *
 * Deck, Collection, Sets and Lists each need the same bordered strip with primary controls on
 * the left, view/sort/filter controls on the right, and optionally a filter panel beneath.
 */
import clsx from 'clsx';
import type { ReactElement, ReactNode } from 'react';

export interface ViewControlsBarProps {
  /** Primary controls (search, board selector). */
  left?: ReactNode;
  /** View, sort, filter and action controls. */
  right?: ReactNode;
  /** Full-width row beneath the controls, inside the same bordered container. */
  below?: ReactNode;
  className?: string;
}

export default function ViewControlsBar({ left, right, below, className }: ViewControlsBarProps): ReactElement {
  return (
    <div className={clsx('border-b border-zinc-800/50 bg-zinc-900/30 px-4 sm:px-6', className)}>
      <div className="flex flex-wrap items-center justify-between gap-3 py-3">
        <div className="flex min-w-0 flex-wrap items-center gap-3">{left}</div>
        <div className="flex shrink-0 flex-wrap items-center gap-2 sm:gap-3">{right}</div>
      </div>
      {below}
    </div>
  );
}
